var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { get } from 'lodash';
import moment from 'moment-timezone';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import * as yup from 'yup';
import { getCurrentProvider, getPatientMedicationByAuthSystem, getPatientMedicationById, patchMedication } from '../Async/MedicationsSummaryAsync';
import { AutosaveForm, AutosaveOperations } from '../Components/AutosaveForm/AutosaveForm';
import { AutosaveStyledSelect } from '../Components/AutosaveForm/AutosaveStyledSelect';
import { MetaForm, MetaFormContext } from '../Components/AutosaveForm/MetaForm';
import { LayoutCentral } from '../Components/LayoutCentral';
import { MaskedTextField } from '../Components/MaskedTextField';
import { LoadingPlaceholder } from '../Components/Placeholder';
import { isSingleSelectSingleValue } from '../Components/StyledSelect';
import { SettingsStatus, useMedicationSettings } from '../Config/MedicationConfig';
import { ClinicalIndicationType, ConsentDetailStatus, CrossCheckType, MedicationCourse, MedicationStatus, MedicationType, prettyPrintMedicationType } from '../Contracts/MedicationModels';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { usePermissions } from '../Hooks/usePermissions';
import { invalidDate, requiredField } from '../Medications.en';
import { MedicationsPermissions } from '../MedicationsPermissions';
import { durationLessThanOneYear, performedDate } from '../MedicationSummary/MedicationSummaryDuration';
import { routeForDetails } from '../Routes';
import { ValidDateFormats } from '../Shared/DateUtilities';
import { useHttpConfig } from '../Shared/HttpRequestExecutor';
import { validMoment } from '../Shared/Validators/TimeDate';
import { DosageInstructionsSection } from './Fields/DosageInstructions/DosageInstructionsSection';
import { useDosageInstructionState } from './Fields/DosageInstructions/useDosageInstructionState';
import { MedicationAlertBanner } from './MedicationAlertBanner/MedicationAlertBanner';
import { MedicationAuthorisation } from './MedicationAuthorisation';
import { MedicationDetailsFields } from './MedicationDetailsFields';
import { MedicationInfoHeader } from './MedicationInfoHeader';
import styles from './MedicationOverview.module.css';
import { MedicationOverviewSection, SectionContainer } from './MedicationOverviewSection';
import { MedicationPaymentDetails } from './MedicationPaymentDetails';
import { MedicationProblemsAndViewingRights } from './MedicationProblemsAndViewingRights';
import { externalWitnessSelection, freeTextClinicalIndicationSelection, renderItemToMenuKey, renderItemToString } from '../Shared/MedicationSharedMethods';
import { MedicationTitle } from './MedicationTitle';
import { PatientMedicationHistoryDisplay } from './PatientMedicationHistoryDisplay';
import { SupplementalDetailsSection } from './SupplementalDetailsSection';
import { SupportiveMedicationDocumentation } from './SupportiveMedicationDocumentation';
export function convertContractToForm(contract) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24;
    var medication = contract.medication
        ? __assign(__assign({}, contract.medication), { originalMedication: contract.originalMedication }) : null;
    return {
        updatedOn: contract.updatedOn,
        updatedBy: contract.updatedBy,
        medicationType: { value: contract.medicationType },
        name: contract.name,
        notes: (_a = contract.notes) !== null && _a !== void 0 ? _a : '',
        medication: medication,
        medicationCourse: contract.course,
        numberOfPacks: contract.productPackAmount.toString(),
        repeats: (_c = (_b = contract.repeatsAmount) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '',
        maximumSupplyPermitted: contract.maximumSupplyPermitted === 0 ? '' : (_e = (_d = contract.maximumSupplyPermitted) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '',
        isFreeTextMedication: contract.isFreeTextMedication,
        supplyAllRepeatsAtOnce: contract.supplyAllRepeatsAtOnce,
        scriptRetainedByPharmacy: contract.scriptRetainedByPharmacy,
        patientConsentsToActiveScriptList: contract.patientConsentsToActiveScriptList,
        patientConsentsToMyHrUpload: contract.patientConsentsToMyHrUpload,
        minimumDaysBetweenRepeats: contract.minimumDaysBetweenRepeats
            ? contract.minimumDaysBetweenRepeats.toString()
            : null,
        expiresOn: contract.expiresOn ? moment(contract.expiresOn, ValidDateFormats.IsoFormat) : null,
        medicationExpiry: { value: contract.medicationExpiry },
        pharmacyRequestId: contract.pharmacyRequestId,
        performedOn: moment(contract.performedOn, ValidDateFormats.IsoFormat).format(ValidDateFormats.Edit),
        clinicalIndicationType: (_g = (_f = contract.clinicalIndication) === null || _f === void 0 ? void 0 : _f.type) !== null && _g !== void 0 ? _g : null,
        codedClinicalIndication: ((_h = contract.clinicalIndication) === null || _h === void 0 ? void 0 : _h.type) === ClinicalIndicationType.FreeText
            ? __assign({}, freeTextClinicalIndicationSelection) : (_k = (_j = contract.clinicalIndication) === null || _j === void 0 ? void 0 : _j.indication) !== null && _k !== void 0 ? _k : null,
        freeTextClinicalIndication: (_m = (_l = contract.clinicalIndication) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : null,
        viewingRight: contract.viewingRight,
        problems: (_o = contract.problems) !== null && _o !== void 0 ? _o : [],
        authorisingPrescriber: (_q = (_p = contract.verbalOrderDetail) === null || _p === void 0 ? void 0 : _p.authorisingPrescriber) !== null && _q !== void 0 ? _q : null,
        witnessOneType: (_t = (_s = (_r = contract.verbalOrderDetail) === null || _r === void 0 ? void 0 : _r.witnessOne) === null || _s === void 0 ? void 0 : _s.type) !== null && _t !== void 0 ? _t : null,
        witnessOneProvider: ((_v = (_u = contract.verbalOrderDetail) === null || _u === void 0 ? void 0 : _u.witnessOne) === null || _v === void 0 ? void 0 : _v.type) === CrossCheckType.External
            ? __assign({}, externalWitnessSelection) : (_y = (_x = (_w = contract.verbalOrderDetail) === null || _w === void 0 ? void 0 : _w.witnessOne) === null || _x === void 0 ? void 0 : _x.provider) !== null && _y !== void 0 ? _y : null,
        witnessOneName: (_1 = (_0 = (_z = contract.verbalOrderDetail) === null || _z === void 0 ? void 0 : _z.witnessOne) === null || _0 === void 0 ? void 0 : _0.name) !== null && _1 !== void 0 ? _1 : null,
        witnessOneContactDetails: (_4 = (_3 = (_2 = contract.verbalOrderDetail) === null || _2 === void 0 ? void 0 : _2.witnessOne) === null || _3 === void 0 ? void 0 : _3.contactDetails) !== null && _4 !== void 0 ? _4 : null,
        allowBrandSubstitution: contract.allowBrandSubstitution,
        scheme: (_6 = (_5 = contract.paymentDetails) === null || _5 === void 0 ? void 0 : _5.type) !== null && _6 !== void 0 ? _6 : null,
        snapshot: (_8 = (_7 = contract.paymentDetails) === null || _7 === void 0 ? void 0 : _7.snapshot) !== null && _8 !== void 0 ? _8 : null,
        paymentDetailAuthorityNumber: (_11 = (_10 = (_9 = contract.paymentDetails) === null || _9 === void 0 ? void 0 : _9.paymentDetail) === null || _10 === void 0 ? void 0 : _10.authorityNumber) !== null && _11 !== void 0 ? _11 : '',
        paymentDetailApprovalNumber: (_14 = (_13 = (_12 = contract.paymentDetails) === null || _12 === void 0 ? void 0 : _12.paymentDetail) === null || _13 === void 0 ? void 0 : _13.approvalNumber) !== null && _14 !== void 0 ? _14 : '',
        paymentDetailReturnToPatient: (_17 = (_16 = (_15 = contract.paymentDetails) === null || _15 === void 0 ? void 0 : _15.paymentDetail) === null || _16 === void 0 ? void 0 : _16.returnToPatient) !== null && _17 !== void 0 ? _17 : false,
        paymentDetailPreviousAuthority: (_20 = (_19 = (_18 = contract.paymentDetails) === null || _18 === void 0 ? void 0 : _18.paymentDetail) === null || _19 === void 0 ? void 0 : _19.previousAuthority) !== null && _20 !== void 0 ? _20 : false,
        nonStandardPackSize: contract.nonStandardPackSize.toString(),
        isNonStandardPackSize: contract.isNonStandardPackSize,
        jurisdictionalControlledSubstanceReference: contract.jurisdictionalControlledSubstanceReference,
        nominatedDispensingPharmacy: contract.nominatedDispensingPharmacy,
        isUrgentSupplyScriptOwing: contract.isUrgentSupplyScriptOwing,
        consentDetailsDescription: (_22 = (_21 = contract.consentDetails) === null || _21 === void 0 ? void 0 : _21.description) !== null && _22 !== void 0 ? _22 : '',
        consentDetailsStatus: (_24 = (_23 = contract.consentDetails) === null || _23 === void 0 ? void 0 : _23.status) !== null && _24 !== void 0 ? _24 : ConsentDetailStatus.NotSet
    };
}
function convertFormToPatch(form) {
    var _a, _b;
    var paymentDetails = {};
    if (form.scheme) {
        paymentDetails.scheme = form.scheme;
    }
    paymentDetails.paymentDetail = {
        approvalNumber: form.paymentDetailApprovalNumber,
        authorityNumber: form.paymentDetailAuthorityNumber,
        previousAuthority: form.paymentDetailPreviousAuthority,
        returnToPatient: form.paymentDetailReturnToPatient
    };
    if (form.snapshot) {
        paymentDetails.snapshot = form.snapshot;
    }
    return {
        notes: form.notes,
        medicationType: (_b = (_a = form.medicationType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null,
        medicationExpiry: form.medicationExpiry.value,
        pharmacyRequestId: form.pharmacyRequestId,
        paymentDetails: paymentDetails,
        course: form.medicationCourse,
        isFreeTextMedication: form.isFreeTextMedication,
        supplyAllRepeatsAtOnce: form.supplyAllRepeatsAtOnce,
        scriptRetainedByPharmacy: form.scriptRetainedByPharmacy,
        minimumDaysBetweenRepeats: form.minimumDaysBetweenRepeats ? Number(form.minimumDaysBetweenRepeats) : null,
        patientConsentsToActiveScriptList: form.patientConsentsToActiveScriptList,
        patientConsentsToMyHrUpload: form.patientConsentsToMyHrUpload,
        productPackAmount: form.numberOfPacks ? Number(form.numberOfPacks) : 0,
        repeatsAmount: form.repeats === '' ? null : Number(form.repeats),
        maximumSupplyPermitted: form.maximumSupplyPermitted ? Number(form.maximumSupplyPermitted) : null,
        expiresOn: form.expiresOn ? form.expiresOn.format(ValidDateFormats.IsoFormat) : null,
        performedOn: moment(form.performedOn, ValidDateFormats.Edit).format(ValidDateFormats.IsoFormat),
        viewingRight: form.viewingRight
            ? {
                code: form.viewingRight.code,
                name: form.viewingRight.name
            }
            : null,
        problems: form.problems
            ? form.problems.map(function (x) { return ({
                id: x.id,
                authoringSystem: x.authoringSystem,
                authoringSystemForeignKey: x.authoringSystemForeignKey
            }); })
            : [],
        allowBrandSubstitution: !!form.allowBrandSubstitution,
        nonStandardPackSize: form.nonStandardPackSize ? Number(form.nonStandardPackSize) : 0,
        isNonStandardPackSize: !!form.isNonStandardPackSize,
        codedClinicalIndication: form.clinicalIndicationType === ClinicalIndicationType.Coded && form.codedClinicalIndication !== null
            ? {
                indication: form.codedClinicalIndication
            }
            : null,
        freeTextClinicalIndication: form.clinicalIndicationType === ClinicalIndicationType.FreeText && form.freeTextClinicalIndication !== null
            ? {
                value: form.freeTextClinicalIndication
            }
            : null,
        verbalOrderDetail: {
            authorisingPrescriber: form.authorisingPrescriber
                ? {
                    id: form.authorisingPrescriber.id,
                    authoringSystem: form.authorisingPrescriber.authoringSystem,
                    authoringSystemForeignKey: form.authorisingPrescriber.authoringSystemForeignKey
                }
                : null,
            witnessOneProvider: form.witnessOneType === CrossCheckType.Provider && form.witnessOneProvider !== null
                ? {
                    crossCheckBy: form.updatedBy,
                    crossCheckOn: form.updatedOn,
                    provider: {
                        id: form.witnessOneProvider.id,
                        authoringSystem: form.witnessOneProvider.authoringSystem,
                        authoringSystemForeignKey: form.witnessOneProvider.authoringSystemForeignKey
                    }
                }
                : null,
            witnessOneExternal: form.witnessOneType === CrossCheckType.External &&
                form.witnessOneName !== null &&
                form.witnessOneContactDetails !== null
                ? {
                    crossCheckBy: form.updatedBy,
                    crossCheckOn: form.updatedOn,
                    name: form.witnessOneName,
                    contactDetails: form.witnessOneContactDetails
                }
                : null
        },
        jurisdictionalControlledSubstanceReference: form.jurisdictionalControlledSubstanceReference,
        nominatedDispensingPharmacy: form.nominatedDispensingPharmacy,
        isUrgentSupplyScriptOwing: form.isUrgentSupplyScriptOwing,
        consentDetails: {
            description: form.consentDetailsDescription,
            status: form.consentDetailsStatus
        }
    };
}
var medicationOverviewSchema = yup.object({
    updatedOn: yup.string(),
    updatedBy: yup.string(),
    name: yup.string(),
    notes: yup.string(),
    medication: yup.object().nullable(),
    medicationType: yup.object(),
    medicationCourse: yup.mixed().test({
        name: 'Course must be selected',
        message: 'Please make a selection',
        test: function (value) {
            return value !== MedicationCourse.None;
        }
    }),
    numberOfPacks: yup.string().when('medicationType', {
        is: function (value) {
            return (value.value === MedicationType.TakeHomeScript ||
                value.value === MedicationType.EnrmcScript ||
                value.value === MedicationType.ComplementaryTherapyOrder);
        },
        then: yup.string().test({
            name: 'Must be greater than 0',
            message: 'Must be greater than 0',
            test: function (value) {
                return !isNaN(Number(value)) && Number(value) > 0;
            }
        })
    }),
    repeats: yup.string().when('medicationType', {
        is: function (value) { return value.value === MedicationType.TakeHomeScript; },
        then: yup.string().test({
            name: 'Must be 0 or greater',
            message: 'Must be 0 or greater',
            test: function (value) {
                if (value == null || value == '')
                    return false;
                return !isNaN(Number(value)) && Number(value) >= 0;
            }
        })
    }),
    maximumSupplyPermitted: yup.string().when('medicationType', {
        is: function (value) {
            return value.value === MedicationType.EnrmcScript;
        },
        then: yup.string().test({
            name: 'Must be blank or a number greater than 0',
            message: 'Must be blank or a number greater than 0',
            test: function (value) {
                return value === '' || (Number(value) > 0 && Number(value) <= 999999);
            }
        })
    }),
    isFreeTextMedication: yup.boolean(),
    supplyAllRepeatsAtOnce: yup.boolean(),
    scriptRetainedByPharmacy: yup.boolean(),
    minimumDaysBetweenRepeats: yup
        .string()
        .nullable()
        .test({
        name: 'Valid repeat interval',
        message: 'Must be less than 365 days',
        test: function (value) {
            var interval = value ? Number(value) : 0;
            return interval < 366;
        }
    }),
    patientConsentsToActiveScriptList: yup.boolean(),
    patientConsentsToMyHrUpload: yup.boolean(),
    expiresOn: yup
        .object()
        .nullable()
        .when('medicationType', {
        is: function (_a) {
            var value = _a.value;
            return value === MedicationType.MedicationHistory;
        },
        then: yup.object().test({
            name: 'Valid expiry date',
            message: invalidDate,
            test: function (value) {
                var performedOn = get(this.parent, 'performedOn');
                var performedOnMoment = moment(performedOn, ValidDateFormats.Edit);
                if (!!performedOn && performedOnMoment.isValid() && !!value) {
                    return moment(value).isSameOrAfter(performedOnMoment, 'day');
                }
                return true;
            }
        }),
        otherwise: yup
            .object()
            .test({
            name: 'Valid expiry date',
            message: 'Date must be after today',
            test: function (value) {
                return validMoment(value) && moment(value).isSameOrAfter(moment(), 'day');
            }
        })
            .test({
            name: 'Valid expiry duration',
            message: 'Duration too long',
            test: function (value) {
                var performedOn = get(this.parent, 'performedOn');
                var performedOnMoment = moment(performedOn, ValidDateFormats.Edit);
                if (!!performedOn && performedOnMoment.isValid() && !!value) {
                    return durationLessThanOneYear(moment(value, ValidDateFormats.IsoFormat).endOf('day'), performedDate(performedOnMoment.endOf('day').format(ValidDateFormats.IsoFormat), ValidDateFormats.IsoFormat));
                }
                return true;
            }
        })
    }),
    medicationExpiry: yup.object().required(),
    pharmacyRequestId: yup.string().nullable(),
    performedOn: yup
        .string()
        .transform(function (v) { return (v === null ? '' : v); })
        .required('DD/MM/YYYY')
        .matches(/^\d{1,2}\/\d{1,2}\/\d{4}$/, 'DD/MM/YYYY')
        .test({
        name: 'RecordedDateToday',
        message: 'Recorded date must be today',
        test: function (value) {
            var todaysDate = moment().format(ValidDateFormats.Edit);
            return value === todaysDate;
        }
    }),
    clinicalIndicationType: yup.mixed().nullable(),
    codedClinicalIndication: yup
        .object()
        .nullable()
        .test({
        name: 'ClinicalIndicationRequired',
        message: 'Reason to prescribe must be provided',
        test: function (value) {
            var medicationCourse = get(this.parent, 'medicationCourse');
            var poisonSchedule = get(this.parent, 'medication.poisonSchedule');
            var medicationType = get(this.parent, 'medicationType.value');
            if ((medicationType === MedicationType.EnrmcScript &&
                (medicationCourse === MedicationCourse.ShortCourse || (poisonSchedule === null || poisonSchedule === void 0 ? void 0 : poisonSchedule.code) === 'S8'))
                ||
                    ((medicationType === MedicationType.EnrmcScript
                        || medicationType === MedicationType.ComplementaryTherapyOrder)
                        && medicationCourse === MedicationCourse.AsRequired)) {
                return !!value;
            }
            return true;
        }
    }),
    freeTextClinicalIndication: yup
        .string()
        .nullable()
        .test({
        name: 'ClinicalIndicationRequired',
        message: 'Reason to prescribe must be provided',
        test: function (value) {
            var medicationCourse = get(this.parent, 'medicationCourse');
            var poisonSchedule = get(this.parent, 'medication.poisonSchedule');
            var medicationType = get(this.parent, 'medicationType.value');
            if ((medicationType === MedicationType.EnrmcScript &&
                (medicationCourse === MedicationCourse.ShortCourse || (poisonSchedule === null || poisonSchedule === void 0 ? void 0 : poisonSchedule.code) === 'S8'))
                ||
                    ((medicationType === MedicationType.EnrmcScript
                        || medicationType === MedicationType.ComplementaryTherapyOrder)
                        && medicationCourse === MedicationCourse.AsRequired)) {
                return !!value;
            }
            return true;
        }
    }),
    viewingRight: yup.object().required(requiredField).nullable(),
    problems: yup.array(yup.object()),
    authorisingPrescriber: yup.object().nullable(),
    witnessOneType: yup.mixed().nullable(),
    witnessOneProvider: yup.object().nullable(),
    witnessOneName: yup.string().nullable(),
    witnessOneContactDetails: yup.string().nullable(),
    allowBrandSubstitution: yup.boolean(),
    paymentDetailAuthorityNumber: yup.string(),
    paymentDetailApprovalNumber: yup.string(),
    paymentDetailReturnToPatient: yup.boolean(),
    paymentDetailPreviousAuthority: yup.boolean(),
    snapshot: yup.object().nullable(),
    scheme: yup.mixed().nullable(),
    isNonStandardPackSize: yup.boolean(),
    nonStandardPackSize: yup.string().when('isNonStandardPackSize', {
        is: function (value) { return value === true; },
        then: yup.string().test({
            name: 'Must be greater than 0',
            message: 'Must be greater than 0',
            test: function (value) {
                return !isNaN(Number(value)) && Number(value) > 0;
            }
        })
    }),
    jurisdictionalControlledSubstanceReference: yup.string().nullable(),
    nominatedDispensingPharmacy: yup.string().nullable(),
    isUrgentSupplyScriptOwing: yup.boolean(),
    consentDetailsDescription: yup.string(),
    consentDetailsStatus: yup.mixed()
});
var MedicationTypeField = function (props) {
    // ComplementaryTherapyOrder is a valid type, but should not be an option in the medication type selection drop down menu.
    var validMedicationTypes = [];
    var permissions = usePermissions({
        prescribeMedicationsTakeHomeScript: MedicationsPermissions.PrescribeMedicationsTakeHomeScript,
        prescribeMedicationsEnrmcScript: MedicationsPermissions.PrescribeMedicationsEnrmcScript,
        prescribeMedicationsMedicationOrder: MedicationsPermissions.PrescribeMedicationsMedicationOrder,
        prescribeMedicationsMedicationHistory: MedicationsPermissions.PrescribeMedicationsMedicationHistory
    });
    if (permissions.prescribeMedicationsTakeHomeScript) {
        validMedicationTypes.push({ value: MedicationType.TakeHomeScript });
    }
    if (permissions.prescribeMedicationsMedicationOrder) {
        validMedicationTypes.push({ value: MedicationType.MedicationOrder });
    }
    if (permissions.prescribeMedicationsMedicationHistory) {
        validMedicationTypes.push({ value: MedicationType.MedicationHistory });
    }
    if (permissions.prescribeMedicationsEnrmcScript) {
        validMedicationTypes.push({ value: MedicationType.EnrmcScript });
    }
    return (React.createElement("div", { className: styles.medicationTypeSelector },
        React.createElement(AutosaveStyledSelect, { readOnly: props.readOnly || props.patientMedication.isFreeTextMedication, field: 'medicationType', label: 'Medication type', maxResults: 4, itemToString: renderItemToString, itemToMenuKey: renderItemToMenuKey, customItemRender: function (suggestion) { return React.createElement("span", null, prettyPrintMedicationType(suggestion === null || suggestion === void 0 ? void 0 : suggestion.value)); }, onSelection: function (it) {
                if (isSingleSelectSingleValue(it)) {
                    props.onChangeMedicationType(it.value);
                }
            }, suggestions: validMedicationTypes, testId: 'selection-input-medication-type', hideWarningEmptyHelperText: true })));
};
export var MedicationOverviewLoader = function (props) {
    var httpConfig = useHttpConfig();
    var httpProviderConfig = useHttpConfig();
    var patientMedicationAsync = useAsync({
        httpConfig: httpConfig,
        getApi: typeof props.patientMedicationId == 'string' ? getPatientMedicationById : getPatientMedicationByAuthSystem
    });
    var currentProviderAsync = useAsync({
        httpConfig: httpProviderConfig,
        getApi: getCurrentProvider
    });
    function getMedication() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (typeof props.patientMedicationId == 'string')
                        patientMedicationAsync.getApi(props.patientMedicationId);
                    else
                        patientMedicationAsync.getApi(props.patientMedicationId.authoringSystem, props.patientMedicationId.authoringSystemForeignKey);
                }
                catch (err) {
                    console.error(err);
                }
                return [2 /*return*/];
            });
        });
    }
    function getCurrentProviderInfo() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    currentProviderAsync.getApi(props.service.authoringSystem, props.service.authoringSystemForeignKey);
                }
                catch (err) {
                    console.error(err);
                }
                return [2 /*return*/];
            });
        });
    }
    useEffect(function () {
        var timeOut = setTimeout(function () {
            getMedication();
            getCurrentProviderInfo();
        }, 0);
        return function () {
            if (timeOut)
                clearTimeout(timeOut);
        };
    }, []);
    useEffect(function () {
        return function () {
            props.onUnmount();
        };
    }, []);
    var patientMedication = patientMedicationAsync.data;
    var currentProvider = currentProviderAsync.data;
    if (patientMedicationAsync.status !== UseAsyncStatus.Loaded ||
        patientMedication === null ||
        currentProviderAsync.status !== UseAsyncStatus.Loaded) {
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    }
    else {
        return (React.createElement(MedicationOverview, __assign({}, props, { patientMedication: patientMedication, currentProvider: currentProvider })));
    }
};
var FormTracker = function (props) {
    var metaForm = useContext(MetaFormContext);
    var formUnsaved = metaForm.formSubmitting || metaForm.formInvalid || metaForm.formFailedToSave;
    useEffect(function () {
        if (formUnsaved) {
            props.onFormUnsaved();
        }
        else {
            props.onFormSaved();
        }
    }, [formUnsaved]);
    return null;
};
function hideSection(medicationType, validTypes, hide) {
    if (hide === void 0) { hide = false; }
    if (hide)
        return true;
    return !validTypes.includes(medicationType);
}
var MedicationOverview = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var _l = __read(useState(props.patientMedication), 2), patientMedication = _l[0], setPatientMedication = _l[1];
    var _m = __read(useState(false), 2), showPatientMedicationHistory = _m[0], setPatientMedicationHistory = _m[1];
    var _o = __read(useState({
        maxPacks: (_c = (_b = (_a = props.patientMedication.paymentDetails) === null || _a === void 0 ? void 0 : _a.snapshot) === null || _b === void 0 ? void 0 : _b.maxNumberOfPacks) !== null && _c !== void 0 ? _c : 0,
        maxRepeats: (_f = (_e = (_d = props.patientMedication.paymentDetails) === null || _d === void 0 ? void 0 : _d.snapshot) === null || _e === void 0 ? void 0 : _e.maxNumberOfRepeats) !== null && _f !== void 0 ? _f : 0,
        maxPerPack: (_j = (_h = (_g = props.patientMedication.paymentDetails) === null || _g === void 0 ? void 0 : _g.snapshot) === null || _h === void 0 ? void 0 : _h.maxQuantityPerPack) !== null && _j !== void 0 ? _j : 0
    }), 2), maxMedsInfo = _o[0], setMaxMedsInfo = _o[1];
    var _p = __read(useState(false), 2), paymentDetailsAuthorityRequired = _p[0], setPaymentDetailsAuthorityRequired = _p[1];
    var medicationSettings = useMedicationSettings();
    var location = useLocation();
    var history = useHistory();
    var rootMatch = useRouteMatch();
    useEffect(function () {
        setPatientMedicationHistory(false);
    }, [(_k = location.state) === null || _k === void 0 ? void 0 : _k.eventId]);
    var onUpdate = function (patient) {
        setPatientMedication(patient);
        props.onUpdate();
    };
    var dosageInstructionState = useDosageInstructionState({
        patient: patientMedication,
        onUpdate: onUpdate
    });
    var changeMedicationType = dosageInstructionState.changeMedicationType;
    if (medicationSettings && medicationSettings.status !== SettingsStatus.Loaded)
        return (React.createElement(LayoutCentral, null,
            React.createElement(LoadingPlaceholder, null)));
    var handleMedicationChosen = function () {
        // Logging to make sure system is working as intended.
        console.log('Medication chosen');
    };
    var handleNavigateToMedication = function (patientMedicationId) {
        history.push(routeForDetails(rootMatch.url, patientMedicationId), {
            eventId: moment().format(ValidDateFormats.DateTimeIso)
        });
    };
    return (React.createElement(MetaForm, null,
        React.createElement(FormTracker, { onFormUnsaved: props.onFormUnsaved, onFormSaved: props.onFormSaved }),
        React.createElement(AutosaveForm, { initialContractValue: patientMedication, autosaveOperation: AutosaveOperations.Patch, mapFormToAPIContract: convertFormToPatch, mapGetContractToForm: convertContractToForm, serverCallback: function (patch) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, patchMedication(patientMedication.id, patch)];
            }); }); }, onSubmitted: function (form, response) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var verbalOrderDetail = patientMedication.verbalOrderDetail;
                if (patientMedication.verbalOrderDetail != null && (response === null || response === void 0 ? void 0 : response.verbalOrderDetail) == null) {
                    verbalOrderDetail = null;
                }
                else if (patientMedication.verbalOrderDetail == null && (response === null || response === void 0 ? void 0 : response.verbalOrderDetail) != null) {
                    verbalOrderDetail = {
                        status: response.verbalOrderDetail.status,
                        authorisingPrescriber: null,
                        assignedTo: null,
                        witnessOne: null,
                        witnessTwo: null
                    };
                }
                else if (patientMedication.verbalOrderDetail != null && (response === null || response === void 0 ? void 0 : response.verbalOrderDetail) != null) {
                    verbalOrderDetail = __assign(__assign({}, patientMedication.verbalOrderDetail), { status: response.verbalOrderDetail.status, authorisingPrescriber: form.authorisingPrescriber, witnessOne: {
                            type: (_a = form.witnessOneType) !== null && _a !== void 0 ? _a : CrossCheckType.Provider,
                            crossCheckBy: form.updatedBy,
                            crossCheckOn: form.updatedOn,
                            provider: form.witnessOneProvider,
                            name: form.witnessOneName,
                            contactDetails: form.witnessOneContactDetails
                        } });
                }
                onUpdate(__assign(__assign({}, patientMedication), { originalMedication: (_c = (_b = form.medication) === null || _b === void 0 ? void 0 : _b.originalMedication) !== null && _c !== void 0 ? _c : null, name: form.name, course: form.medicationCourse, expiresOn: (_e = (_d = form.expiresOn) === null || _d === void 0 ? void 0 : _d.format(ValidDateFormats.IsoFormat)) !== null && _e !== void 0 ? _e : '', medication: form.medication, medicationType: (_g = (_f = form.medicationType) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : MedicationType.TakeHomeScript, performedOn: form.performedOn, clinicalIndication: {
                        type: (_h = form.clinicalIndicationType) !== null && _h !== void 0 ? _h : ClinicalIndicationType.Coded,
                        indication: form.codedClinicalIndication,
                        value: form.freeTextClinicalIndication
                    }, problems: form.problems, productPackAmount: isNaN(Number(form.numberOfPacks)) ? 0 : Number(form.numberOfPacks), repeatsAmount: isNaN(Number(form.repeats)) ? 0 : Number(form.repeats), updatedBy: form.updatedBy, updatedOn: form.updatedOn, viewingRight: form.viewingRight, verbalOrderDetail: verbalOrderDetail }));
            }, validationSchema: medicationOverviewSchema, render: function (form) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                var medicationType = (_b = (_a = form.formValues.medicationType) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : MedicationType.TakeHomeScript;
                var readOnly = patientMedication.status !== MedicationStatus.Draft;
                var disallowedTypes = [
                    MedicationType.MedicationHistory,
                    MedicationType.ComplementaryTherapyOrder
                ];
                var showVerbalOrder = patientMedication.verbalOrderDetail != null &&
                    !disallowedTypes.includes(medicationType) &&
                    !patientMedication.isFreeTextMedication;
                return showPatientMedicationHistory ? (React.createElement(PatientMedicationHistoryDisplay, { patientMedication: patientMedication, onClick: function () { return setPatientMedicationHistory(false); }, onMedicationChosen: handleMedicationChosen, controlledMedicationHandler: props.controlledMedicationHandler })) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.container },
                        React.createElement(MedicationInfoHeader, { updatedBy: patientMedication.updatedBy, updatedOn: patientMedication.updatedOn, onClick: function () { return setPatientMedicationHistory(true); } }),
                        React.createElement("div", null,
                            React.createElement(MedicationTitle, { patientMedication: patientMedication, readOnly: readOnly, onMedicationChosen: handleMedicationChosen, controlledMedicationHandler: props.controlledMedicationHandler, problemsAndViewingRightsHidden: medicationSettings.settings.hideViewingRights &&
                                    medicationSettings.settings.hideProblems }),
                            !(medicationSettings.settings.hideViewingRights &&
                                medicationSettings.settings.hideProblems) && (React.createElement(MedicationProblemsAndViewingRights, { getDefaultViewingRight: props.getDefaultViewingRight, patient: props.patient, service: props.service, patientMedication: patientMedication, hideViewingRights: medicationSettings.settings.hideViewingRights, hideProblems: medicationSettings.settings.hideProblems })),
                            patientMedication.decisionSupportDetail && (React.createElement(MedicationAlertBanner, { patientMedication: patientMedication, decisionSupportDetail: patientMedication.decisionSupportDetail, patient: props.patient, onNavigateToMedication: handleNavigateToMedication, readOnly: readOnly, onMedicationChosen: handleMedicationChosen, controlledMedicationHandler: props.controlledMedicationHandler, showVerbalOrder: showVerbalOrder && !patientMedication.userAuthorisedToPrescribe })),
                            React.createElement("div", { className: styles.content },
                                React.createElement(SectionContainer, null,
                                    React.createElement(MedicationOverviewSection, { title: 'Medication type', hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.MedicationOrder,
                                            MedicationType.MedicationHistory,
                                            MedicationType.EnrmcScript,
                                            MedicationType.ComplementaryTherapyOrder
                                        ]), titleInput: React.createElement(MedicationTypeField, { readOnly: readOnly, patientMedication: patientMedication, onChangeMedicationType: changeMedicationType }) }, showVerbalOrder && (React.createElement(MedicationAuthorisation, { patientMedication: patientMedication, currentType: medicationType, readOnly: readOnly }))),
                                    React.createElement(MedicationOverviewSection, { title: 'Medication details', hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.MedicationOrder,
                                            MedicationType.MedicationHistory,
                                            MedicationType.EnrmcScript,
                                            MedicationType.ComplementaryTherapyOrder
                                        ]), titleInput: patientMedication.status !== MedicationStatus.Draft ? (React.createElement("div", { className: styles.scriptNumberSelector },
                                            React.createElement(MaskedTextField, { readOnly: true, value: (_c = patientMedication.finalisedDetail) === null || _c === void 0 ? void 0 : _c.scriptNumber, label: 'Script number', testId: 'text-input-script-number', alphanumeric: true, hideWarningEmptyHelperText: true }))) : null },
                                        React.createElement(MedicationDetailsFields, { readOnly: readOnly, maxPacks: maxMedsInfo.maxPacks, maxRepeats: maxMedsInfo.maxRepeats, medicationStatus: patientMedication.status, currentMedicationType: medicationType, poisonScheduleStatus: (_f = (_e = (_d = patientMedication.medication) === null || _d === void 0 ? void 0 : _d.poisonSchedule) === null || _e === void 0 ? void 0 : _e.poisonScheduleStatus) !== null && _f !== void 0 ? _f : null, showAllowBrandSubstitution: !!((_g = patientMedication.medication) === null || _g === void 0 ? void 0 : _g.isTradeProductPack) &&
                                                !((_h = patientMedication.medication) === null || _h === void 0 ? void 0 : _h.isOnLemi), medicationCourse: patientMedication.course, paymentDetailsAuthorityRequired: paymentDetailsAuthorityRequired })),
                                    React.createElement(DosageInstructionsSection, __assign({}, dosageInstructionState, { readOnly: readOnly, patient: patientMedication, currentMedicationType: medicationType, hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.MedicationOrder,
                                            MedicationType.MedicationHistory,
                                            MedicationType.EnrmcScript,
                                            MedicationType.ComplementaryTherapyOrder
                                        ]) })),
                                    React.createElement(SupplementalDetailsSection, { title: 'Supplemental details', readOnly: readOnly, medicationStatus: patientMedication.status, patientMedication: patientMedication, currentMedicationType: medicationType, hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.MedicationOrder,
                                            MedicationType.MedicationHistory,
                                            MedicationType.EnrmcScript,
                                            MedicationType.ComplementaryTherapyOrder
                                        ]) }),
                                    React.createElement(MedicationPaymentDetails, { readOnly: readOnly, patientMedication: patientMedication, currentProvider: props.currentProvider, onChangeMaxMedsInfo: setMaxMedsInfo, onAuthorityRequired: setPaymentDetailsAuthorityRequired, hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.EnrmcScript
                                        ]) }),
                                    React.createElement(MedicationOverviewSection, { title: 'Supporting documentation', subTitle: 'Download supporting PDF docs', hideSection: hideSection(medicationType, [
                                            MedicationType.TakeHomeScript,
                                            MedicationType.MedicationOrder,
                                            MedicationType.MedicationHistory,
                                            MedicationType.EnrmcScript
                                        ], patientMedication.isFreeTextMedication ||
                                            !medicationSettings.settings.enableSupportiveDocumentation), titleInput: React.createElement(SupportiveMedicationDocumentation, { patientMedicationId: patientMedication.id, isTradeProductPack: (_k = (_j = patientMedication.medication) === null || _j === void 0 ? void 0 : _j.isTradeProductPack) !== null && _k !== void 0 ? _k : false }) })))))));
            } })));
};
